<!-- 店铺新品页面 -->
<template>
  <div id="new-commodity">
    <MySizer :val="1" :is-calendar="1" :slot-item="slotItem" @onCalendar="onCalendar($event)" @onScreen="onScreen($event)" @calendarButton="calendarButton($event)">
      <span slot="1">上新</span>
    </MySizer>
    <div>
      <div v-for="(item,index) in shopData" :key="index">
        <span class="new-time">{{ item.showTime }}</span>
        <comList :com-list="item.data" />
      </div>
      <!-- <span class="new-time">3月18</span>
      <comList :com-list="3" /> -->
    </div>
    <div v-if="false" class="no-data">
      <img src="@/assets/images/no-data.png" alt="">
      <p>未能搜索到符合条件的商品，请重新输入时间范围！</p>
    </div>
  </div>
</template>

<script>
import MySizer from '@/components/sizer/index.vue' // 筛选组件
import comList from '../components/commodityList/index.vue' // 商品组件
import { queryMallStoreStockInfo } from '@/api/shop.js'
export default {
  components: {
    comList,
    MySizer
  },
  data() {
    return {
      // 插槽内箭头是否展示
      slotItem: [
        {
          hasArrow: true
        }
      ],
      active: 3,
      startDate: '',
      endDate: '',
      sortVal: -1,
      currentPage: 1,
      pageSize: -1,
      shopData: []
    }
  },
  /**
   * keep-alive生命周期调用时，改变全局背景颜色
   */
  activated() {
    document.getElementById('storeApp').setAttribute('style', 'background-color:#ffffff;')
  },
  /**
   * keep-alive生命周期取消掉用，取消改变背景颜色
   */
  deactivated() {
    document.getElementById('storeApp').removeAttribute('style')
  },
  created() {
    this.onSearch()
  },
  methods: {
    // 筛选时间改变
    onCalendar(e) {
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.onSearch()
    },
    // 查询
    onSearch() {
      let sortVal = -1
      if (this.active > 1) {
        sortVal = this.sortVal
      }
      const jsonobj = {
        FMallStoreId: Number(this.$route.query.storeId),
        StorePageNavigationFOrder: Number(this.$route.query.forder),
        FNavigationName: this.$route.query.name,
        Keyword: '',
        FBeginTime: this.startDate,
        FEndTime: this.endDate,
        FMinPrice: null,
        FMaxPrice: null,
        FSortType: this.active,
        FSortVal: sortVal
      }
      const params = new URLSearchParams()
      params.append('pageNo', this.currentPage)
      params.append('pageSize', this.pageSize)
      params.append('jsonobj', JSON.stringify(jsonobj))
      queryMallStoreStockInfo(params)
        .then(res => {
          const arr = []
          this.shopData = []
          if (res.data) {
            res.data.records.forEach(item => {
              arr.push(item.FCreateTime.split(' ')[0])
            })
            const newArr = new Set(arr)
            newArr.forEach(item => {
              const time = new Date(item)
              const month = time.getMonth() + 1
              const day = time.getDate()
              const showTime = month + '月' + day
              const obj = {
                showTime,
                data: []
              }
              res.data.records.forEach(t => {
                if (t.FCreateTime.split(' ')[0] === item) {
                  obj.data.push(t)
                }
              })
              this.shopData.push(obj)
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  #new-commodity{
    .new-time{
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      margin-top: 20px;
      display: block;
    }
    .no-data{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 92px 0;
      img{
        width: 184px;
        height: 184px;
      }
      p{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
  }
</style>
